import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => ({
  skeleton: {
    display: "flex",
    flexDirection: "column",
    gap: 6
  },
  skeletonTile: {
    aspectRatio: "1 / 1",
    height: "auto !important",
    minHeight: 148,
    borderRadius: `${theme.tokens.radius.tile}px !important`,
    marginBottom: 6
  }
}));

export default withCustomStyles;
